// Services
import localStorageService from '../utils/services/localStorage/localStorage';
import { removeCapacitorAuthCookie, setCapacitorAuthCookie } from './capacitorAuthService';

// Constants
import { USER_LOCAL_STORAGE_TOKEN_KEY } from './authConstants';

const BETTER_AUTH_SESSION_USER_LOCAL_STORAGE_KEY = 'betterAuthSessionUser';

// Cached user data so we don't need to query the server on app init.
export type BetterAuthSessionUser = {
    _id: string;
    rootBoardId: string;
};

export const getCurrentUserToken = (): string | null => localStorageService.getItem(USER_LOCAL_STORAGE_TOKEN_KEY);

export const setCurrentUserToken = (value: string): void => {
    localStorageService.setItem(USER_LOCAL_STORAGE_TOKEN_KEY, value);

    // Update token stored on Electron main process

    window.desktopIntegration?.setMnToken?.(value);

    // Update token stored on the Native Capacitor side
    setCapacitorAuthCookie(value);
};

export const removeCurrentUserToken = (): void => {
    localStorageService.removeItem(USER_LOCAL_STORAGE_TOKEN_KEY);

    // Update token stored on Electron main process

    window.desktopIntegration?.setMnToken?.(undefined);

    // Remove token stored on the Native Capacitor side
    removeCapacitorAuthCookie();
};

const getRememberedBetterAuthSessionUserData = (user: unknown): BetterAuthSessionUser | null => {
    if (!user || typeof user !== 'object') return null;

    const sessionUser = user as Partial<BetterAuthSessionUser>;
    if (typeof sessionUser._id !== 'string' || typeof sessionUser.rootBoardId !== 'string') return null;

    return {
        _id: sessionUser._id,
        rootBoardId: sessionUser.rootBoardId,
    };
};

export const getRememberedBetterAuthSessionUser = (): BetterAuthSessionUser | null => {
    const rawSessionUser = localStorageService.getItem(BETTER_AUTH_SESSION_USER_LOCAL_STORAGE_KEY);
    if (!rawSessionUser) return null;

    try {
        const sessionUser = JSON.parse(rawSessionUser);
        return getRememberedBetterAuthSessionUserData(sessionUser);
    } catch {
        localStorageService.removeItem(BETTER_AUTH_SESSION_USER_LOCAL_STORAGE_KEY);
        return null;
    }
};

export const getHasRememberedBetterAuthSessionUser = (): boolean => !!getRememberedBetterAuthSessionUser();

export const setRememberedBetterAuthSessionUser = (user: unknown): void => {
    const sessionUser = getRememberedBetterAuthSessionUserData(user);
    if (!sessionUser) return;

    localStorageService.setItem(BETTER_AUTH_SESSION_USER_LOCAL_STORAGE_KEY, JSON.stringify(sessionUser));
};

export const removeRememberedBetterAuthSessionUser = (): void => {
    localStorageService.removeItem(BETTER_AUTH_SESSION_USER_LOCAL_STORAGE_KEY);
};
